import React from "react";

const featuresData = [
  {
    id: 1,
    iconSrc: "/images/icon/icon_168.svg",
    title: "Automated Booking",
    description:
      "AI-powered booking between customers and staff on any device.",
  },
  {
    id: 2,
    iconSrc: "/images/icon/icon_169.svg",
    title: "Digital Food Menu",
    description: "Scan, browse, and order — all from your phone via QR code.",
  },
  {
    id: 3,
    iconSrc: "/images/icon/icon_167.svg",
    title: "Digital Loyalty Card",
    description:
      "Reward customers with digital stamps via web—no stamp tool required.",
  },
  {
    id: 4,
    iconSrc: "/images/icon/icon_170.svg",
    title: "Best Deals",
    description:
      "AI detects interest and delivers tailored deals. Find the best deals",
  },
  {
    id: 5,
    iconSrc: "/images/icon/icon_171.svg",
    title: "Leverage AI-powered",
    description:
      "Easily manage bookings and orders — and let AI help you boost sales!",
  },
  {
    id: 6,
    iconSrc: "/images/icon/icon_172.svg",
    title: "Reporting & Analytics",
    description:
      "Track performance, finances, and client trends with AI insights.",
  },
];

export const BusinessFeaturesSection = () => {
  return (
    <div className="py-24 sm:pt-14 bg-dry">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-start justify-between gap-10">
          {/* Left Text Block */}
          <div
            className="w-full lg:w-1/2 text-center lg:text-left"
            data-aos="fade-right"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-white leading-snug inline-block lg:inline">
              Grow your business
              <br />
              <span className="text-red-500 relative inline-block">
                sustainably
                <img
                  src="/images/shape/shape_96.svg"
                  alt="underline"
                  className="absolute -bottom-2 left-1/2 -translate-x-1/2 lg:left-0 lg:translate-x-0 w-40"
                />
              </span>
            </h2>
          </div>

          {/* Right Description Block */}
          <div
            className="w-full lg:w-1/2 text-center lg:text-left"
            data-aos="fade-left"
          >
            <p className="text-white text-base sm:text-lg max-w-md mx-auto lg:mx-0">
              The software that helps you sell more, save time, and build
              lasting client relationships.
            </p>
          </div>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-16">
          {featuresData.map((feature, idx) => (
            <div
              key={feature.id}
              className="bg-drylight p-6 rounded-2xl shadow-md text-text hover:border-2 hover:border-textGray"
              data-aos="fade-up"
              data-aos-delay={idx * 100}
            >
              <img
                src={feature.iconSrc}
                alt="icon"
                className="w-12 h-12 mb-6"
              />
              <h4 className="text-lg font-semibold mb-3 text-white">
                {feature.title}
              </h4>
              <p className="text-sm">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
